var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "inherit",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.042 8.167H8.58l-.163-.158a3.792 3.792 0 1 0-.408.408l.157.164v.46l2.916 2.912.87-.87zm-3.5 0a2.62 2.62 0 0 1-2.625-2.625 2.62 2.62 0 0 1 2.625-2.625 2.62 2.62 0 0 1 2.625 2.625 2.62 2.62 0 0 1-2.625 2.625Z"
  })));
};
export default SvgSearch;